import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import InsightsGridSection from '../Components/studies/InsightsGridSection'
import { Helmet } from "react-helmet-async";
function CaseStudies() {
    return (
        <div>
            <Helmet>
    <title>
        Case Studies | Enterprise AI & ServiceNow Consulting & Technology Solutions | Mobikode
    </title>

    <meta
        name="description"
        content="Explore Mobikode's case studies showcasing real-world technology solutions, Enterprise AI & ServiceNow Consulting projects, innovative approaches, and successful client collaborations."
    />

    <meta
        name="keywords"
        content="Mobikode Case Studies, Case Studies, Technology Case Studies, Enterprise AI & ServiceNow Consulting Case Studies, IT Case Studies, Software Development Case Studies, Client Success Stories, Technology Solutions, Digital Innovation, Mobikode Projects, Client Collaborations"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/case-studies"
    />

    <meta
        property="og:title"
        content="Case Studies | Enterprise AI & ServiceNow Consulting & Technology Solutions | Mobikode"
    />

    <meta
        property="og:description"
        content="Discover Mobikode's case studies and see how we help businesses solve technology challenges through Enterprise AI & ServiceNow Consulting, software solutions, and innovation."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/case-studies"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/insights/bg3.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Case Studies | Enterprise AI & ServiceNow Consulting & Technology Solutions | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's latest case studies, client success stories, technology projects, and Enterprise AI & ServiceNow Consulting solutions."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/insights/bg3.png"
    />
</Helmet>
            <WhoHero
                title="Case Studies"
                text="Find our latest work and collaborations"
                imgData="/assets/insights/bg3.png"
            />
            <InsightsGridSection />
        </div>
    )
}

export default CaseStudies
